import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ISortingValue } from 'search/services/search-params.service';

@Component({
  selector: 'app-sort-mobile',
  templateUrl: './sort-mobile.component.html',
  styleUrls: ['./sort-mobile.component.scss']
})
export class SortMobileComponent {
  @Input() focusResultsNumberButton$: Observable<undefined>;
  @Input() focusSortButton$: Observable<undefined>;
  @Input() calculatedTotalResults: string;
  @Input() pageSize: number;
  @Input() resultsStart: number;
  @Input() resultsEnd: number;
  @Input() sortValue: ISortingValue;

  @Output() searchNumberChanged = new EventEmitter();
  @Output() sortChanged = new EventEmitter();
  @Output() closeSort = new EventEmitter();

  constructor() { }

  public onClose() {
    this.closeSort.emit();
  }

}
